// Postgres numeric columns serialize as strings (e.g. "120.00"); coerce to
// a number so USD currency formatting actually applies
// (String.prototype.toLocaleString ignores the options and drops "$").
export const toNumber = (
  value: number | string | null | undefined,
): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const formatCurrency = (
  value: number | string | null | undefined,
  fallback = '$0.00',
): string => {
  const num = toNumber(value);
  if (num === null) return fallback;
  return num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
